// Mock-Projektdaten für die Stromlaufplan-Anwendung - basierend auf echten Projektdaten
import { v4 as uuidv4 } from 'uuid';

// Standard-Einspeisung für neue Projekte: TN-C-S, dreiphasig, 4×16 mm², NYM-J
export const createDefaultEinspeisung = () => ({
  id: uuidv4(),
  type: 'einspeisung',
  bezeichnung: 'Zuleitung',
  expanded: true,
  data: {
    kabeltyp: 'NYM-J',
    querschnitt: '16',
    aderzahl: 4,
    laenge: '',
    vorabsicherung: '35A',
    netzform: 'TN-C-S',      // Standard: TN-C-S
    phasenanzahl: '3',       // Standard: dreiphasig
    einspeisungTyp: 'hauptleitungsklemme'
  },
  children: []
});

export const createDefaultProject = () => ({
  id: uuidv4(),
  name: 'Neues Projekt',
  address: '',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  // Verteiler-Standardwerte
  verteilerHersteller: 'hager',
  verteilerTyp: 'unterputz',
  teProReihe: '12',
  anzahlFelder: '1',
  anzahlReihen: '3',
  // Standard-Baum mit Einspeisung
  nodes: [createDefaultEinspeisung()]
});

export const mockProjects = [
  {
    id: '1',
    name: 'Schornweisach 128 UV Obergeschoss Unterverteilung',
    address: 'Schornweisach 128, 91486 Bayern - Uehlfeld',
    firma: 'SteuerStrom Elektrotechnik',
    ersteller: 'Patrick Gumbmann',
    zeichnungsnummer: '1044',
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-10-07T09:52:00Z',
    // Verteiler-Daten
    verteilerHersteller: 'hager',
    verteilerTyp: 'unterputz',
    teProReihe: '12',
    anzahlFelder: '1',
    anzahlReihen: '3',
    nodes: [
      {
        id: 'node-1',
        type: 'einspeisung',
        bezeichnung: 'Zuleitung aus HV',
        expanded: true,
        data: {
          kabeltyp: 'NYM-J',
          querschnitt: '16',
          aderzahl: 4,
          laenge: '25',
          vorabsicherung: '35A',
          netzform: 'TN-C-S',
          phasenanzahl: '3'
        },
        children: [
          {
            id: 'node-2',
            type: 'sls',
            bezeichnung: 'SLS E35A 3-polig',
            expanded: true,
            data: {
              hersteller: 'hager',
              artikelnummer: 'HTN335E',
              nennstrom: '35',
              pole: '3',
              bauform: 'Sammelschiene'
            },
            children: [
              {
                id: 'node-3',
                type: 'zaehler',
                bezeichnung: 'EVU Zähler',
                expanded: true,
                data: {
                  typ: 'EHZ',
                  messart: 'direkt',
                  verdrahtung: '10',
                  tarif: 'Eintarif'
                },
                children: [
                  {
                    id: 'node-4',
                    type: 'klemme',
                    bezeichnung: 'Hauptklemme X1',
                    expanded: true,
                    data: {
                      hersteller: 'wago',
                      typ: 'Durchgang',
                      querschnitt: '10',
                      ebenen: '1',
                      funktion: 'L1/L2/L3/N/PE'
                    },
                    children: [
                      // F1 - RCD für Steckdosen
                      {
                        id: 'node-f1',
                        type: 'rcd',
                        bezeichnung: 'F1 - Steckdosen',
                        expanded: true,
                        data: {
                          hersteller: 'hager',
                          artikelnummer: 'CDA463D',
                          nennstrom: '63',
                          fehlerstrom: '30',
                          pole: '4',
                          typ: 'A'
                        },
                        children: [
                          {
                            id: 'node-f1-1',
                            type: 'ls',
                            bezeichnung: 'F1.1 - Herd',
                            expanded: true,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN316',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '3',
                              verbraucher: 'Herd',
                              teilungseinheiten: '3',
                              phase: 'L1'
                            },
                            children: [
                              {
                                id: 'a6e98dac-6c2d-4a20-92ff-ade1ebb1d9ba',
                                type: 'kabel',
                                bezeichnung: 'Herdkabel',
                                expanded: false,
                                data: {
                                  leitungsnr: '1',
                                  kabeltyp: 'NYY-J',
                                  querschnitt: '4',
                                  anzahlAdern: 5,
                                  laenge: '44',
                                  klemmleiste: 'X1',
                                  adern: [
                                    { nr: 1, typ: 'L', bezeichnung: 'br: L1', zuordnung: 'auto' },
                                    { nr: 2, typ: 'L', bezeichnung: 'sw: L2', zuordnung: 'auto' },
                                    { nr: 3, typ: 'L', bezeichnung: 'gr: L3', zuordnung: 'auto' },
                                    { nr: 4, typ: 'N', bezeichnung: 'N', zuordnung: 'auto' },
                                    { nr: 5, typ: 'PE', bezeichnung: 'PE', zuordnung: 'auto' }
                                  ]
                                },
                                children: []
                              },
                              {
                                id: '5e68738b-e1ab-4057-85b1-863631b70bc9',
                                type: 'kabel',
                                bezeichnung: 'Herdkabel2',
                                expanded: false,
                                data: {
                                  leitungsnr: '2',
                                  kabeltyp: 'NYM-J',
                                  querschnitt: '2,5',
                                  anzahlAdern: 5,
                                  laenge: '12',
                                  klemmleiste: 'X1',
                                  adern: [
                                    { nr: 1, typ: 'L', bezeichnung: 'br: L1', zuordnung: 'auto' },
                                    { nr: 2, typ: 'L', bezeichnung: 'sw: L2', zuordnung: 'auto' },
                                    { nr: 3, typ: 'L', bezeichnung: 'gr: L3', zuordnung: 'auto' },
                                    { nr: 4, typ: 'N', bezeichnung: 'N', zuordnung: 'auto' },
                                    { nr: 5, typ: 'PE', bezeichnung: 'PE', zuordnung: 'auto' }
                                  ]
                                },
                                children: []
                              }
                            ]
                          },
                          {
                            id: 'node-f1-2',
                            type: 'ls',
                            bezeichnung: 'F1.2 - Spülmaschine',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Spülmaschine'
                            },
                            children: []
                          },
                          {
                            id: 'node-f1-3',
                            type: 'ls',
                            bezeichnung: 'F1.3 - Eckschrank',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Eckschrank (Grohe Blue)'
                            },
                            children: []
                          },
                          {
                            id: 'node-f1-4',
                            type: 'ls',
                            bezeichnung: 'F1.4 - Backofen',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Backofen'
                            },
                            children: []
                          },
                          {
                            id: 'node-f1-5',
                            type: 'ls',
                            bezeichnung: 'F1.5 - Mikrowelle',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Mikrowelle/Heißluft'
                            },
                            children: []
                          },
                          {
                            id: 'node-f1-6',
                            type: 'ls',
                            bezeichnung: 'F1.6 - Steckdosen WZ',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Steckdosen Wohnzimmer USB'
                            },
                            children: []
                          },
                          {
                            id: 'node-f1-7',
                            type: 'ls',
                            bezeichnung: 'F1.7 - Steckdosen Speise',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Steckdosen Speise'
                            },
                            children: []
                          },
                          {
                            id: 'node-f1-8',
                            type: 'ls',
                            bezeichnung: 'F1.8 - Steckdosen Office',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Steckdosen Office'
                            },
                            children: []
                          },
                          {
                            id: 'node-f1-9',
                            type: 'ls',
                            bezeichnung: 'F1.9 - Steckdosen Bad',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Steckdosen Badezimmer'
                            },
                            children: []
                          },
                          {
                            id: 'node-f1-10',
                            type: 'ls',
                            bezeichnung: 'F1.10 - Steckdose Gast',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Steckdose Gast TV'
                            },
                            children: []
                          },
                          {
                            id: 'node-f1-11',
                            type: 'ls',
                            bezeichnung: 'F1.11 - Garderobe',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Steckdosen Garderobe'
                            },
                            children: []
                          },
                          {
                            id: 'node-f1-12',
                            type: 'ls',
                            bezeichnung: 'F1.12 - Frei',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Frei'
                            },
                            children: []
                          }
                        ]
                      },
                      // F0.x - RCBOs (FI/LS Kombination)
                      {
                        id: 'node-f0-1',
                        type: 'rcbo',
                        bezeichnung: 'F0.1 - Rollos',
                        expanded: false,
                        data: {
                          hersteller: 'hager',
                          artikelnummer: 'ADA916D',
                          nennstrom: '16',
                          fehlerstrom: '30',
                          charakteristik: 'B',
                          pole: '1+N',
                          typ: 'A',
                          verbraucher: 'Rollo Speise, Rollo Küche'
                        },
                        children: []
                      },
                      {
                        id: 'node-f0-2',
                        type: 'rcbo',
                        bezeichnung: 'F0.2 - EBS',
                        expanded: false,
                        data: {
                          hersteller: 'hager',
                          artikelnummer: 'ADC916D',
                          nennstrom: '16',
                          fehlerstrom: '30',
                          charakteristik: 'C',
                          pole: '1+N',
                          typ: 'A',
                          verbraucher: 'EBS Aufgang, EBS Eingang'
                        },
                        children: []
                      },
                      {
                        id: 'node-f0-3',
                        type: 'rcbo',
                        bezeichnung: 'F0.3 - USV',
                        expanded: false,
                        data: {
                          hersteller: 'hager',
                          artikelnummer: 'ADA916D',
                          nennstrom: '16',
                          fehlerstrom: '30',
                          charakteristik: 'B',
                          pole: '1+N',
                          typ: 'A',
                          verbraucher: 'Zu USV, Von USV, Steuerung'
                        },
                        children: []
                      },
                      {
                        id: 'node-f0-5',
                        type: 'rcbo',
                        bezeichnung: 'F0.5 - Doppelsteckdose',
                        expanded: false,
                        data: {
                          hersteller: 'hager',
                          artikelnummer: 'ADA916D',
                          nennstrom: '16',
                          fehlerstrom: '30',
                          charakteristik: 'B',
                          pole: '1+N',
                          typ: 'A',
                          verbraucher: 'Doppelsteckdose in Speise'
                        },
                        children: []
                      },
                      // F2 - RCD für Klimatisierung OG
                      {
                        id: 'node-f2',
                        type: 'rcd',
                        bezeichnung: 'F2 - Klimatisierung OG',
                        expanded: true,
                        data: {
                          hersteller: 'hager',
                          artikelnummer: 'CDA463D',
                          nennstrom: '63',
                          fehlerstrom: '30',
                          pole: '4',
                          typ: 'A'
                        },
                        children: [
                          {
                            id: 'node-f2-1',
                            type: 'ls',
                            bezeichnung: 'F2.1 - Klimaanlage',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Klimaanlage Außengerät'
                            },
                            children: []
                          },
                          {
                            id: 'node-f2-2',
                            type: 'ls',
                            bezeichnung: 'F2.2 - Handtuchheizk.',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Handtuchheizkörper'
                            },
                            children: []
                          },
                          {
                            id: 'node-f2-3',
                            type: 'ls',
                            bezeichnung: 'F2.3 - Dampfbad',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Dampfbad+Switchglas'
                            },
                            children: []
                          },
                          {
                            id: 'node-f2-4',
                            type: 'ls',
                            bezeichnung: 'F2.4 - Ventilator Bad',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Ventilator Bad'
                            },
                            children: []
                          },
                          {
                            id: 'node-f2-5',
                            type: 'ls',
                            bezeichnung: 'F2.5 - Reserve',
                            expanded: false,
                            data: {
                              hersteller: 'hager',
                              artikelnummer: 'MBN116',
                              nennstrom: '16',
                              charakteristik: 'B',
                              pole: '1',
                              verbraucher: 'Reserve'
                            },
                            children: []
                          }
                        ]
                      },
                      // F0.6 - RCBO für Balkon
                      {
                        id: 'node-f0-6',
                        type: 'rcbo',
                        bezeichnung: 'F0.6 - Balkon',
                        expanded: false,
                        data: {
                          hersteller: 'hager',
                          artikelnummer: 'ADA916D',
                          nennstrom: '16',
                          fehlerstrom: '30',
                          charakteristik: 'B',
                          pole: '1+N',
                          typ: 'A',
                          verbraucher: 'Balkon, Wintergarten'
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: '2',
    name: 'Musterhaus Hauptverteilung',
    address: 'Musterstraße 1, 90000 Nürnberg',
    firma: 'Elektro Mustermann',
    ersteller: 'Max Mustermann',
    zeichnungsnummer: '2001',
    createdAt: '2024-03-10T08:00:00Z',
    updatedAt: '2024-03-20T14:30:00Z',
    nodes: []
  }
];

export default mockProjects;
